<!--
 * @Description: 
 * @Author: 山淑兰
 * @Date: 2019-09-06 15:12:11
 * @LastEditTime: 2020-05-13 17:22:59
 * @LastEditors: 山淑兰
 -->

<template>
  <div class="modifyphone">
    <main>
      <div class="modifyphone-con" v-if="nowShow">
        <div class="title">
          修改手机号
        </div>
        <div class="now-tel">
          当前手机号
        </div>
        <div class="now-phone">
          {{userInfo.Phone}}      
        </div>
        <div class="now-code" v-if="codeShow">
          <div class="code-input">
            <input type="text" name="code" placeholder="请输入短信验证码" v-model="code">
          </div>
          <div class="code-btn">
            {{getCAPTCHA}}
          </div>
        </div>
        <div class="now-code-get" v-if="codeBtnShow" @click="getCode">
          获取验证码
        </div>
        <div class="now-code-get"  v-if="codeShow" @click="getSure">
          确 定
        </div>
      </div>
      <div class="modifyphone-con" v-if="modfiyShow">
        <div class="title">
          输入新手机号
        </div>
        <div class="now-code">
          <div class="code-input">
            <input type="text" name="code" placeholder="请输入新手机号" v-model="modfiyphone">
          </div>
        </div>
        <div class="now-code">
          <div class="code-input">
            <input type="text" name="code" placeholder="请输入短信验证码" v-model="code1">
          </div>
          <div class="code-btn code-btn-active" v-if="send"  @click="getCode1">
            {{getCAPTCHA1}}
          </div>
          <div class="code-btn code-btn-no" v-else>
            {{getCAPTCHA1}}
          </div>
        </div>
        <div class="now-code-get" @click="modfiySure">
          确 定
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: '',
      code: '',
      code1: '',
      modfiyphone: '',
      codeShow: false,
      codeBtnShow: true,
      getCAPTCHA: '',
      getCAPTCHA1: '获取验证码',
      send: true,
      nowShow: true,
      modfiyShow: false,
    }
  },
  created() {
    this.myInfo()
  },
  methods: {
    async myInfo() {
      try {
        const params = {
          m:this.$route.query.m,
        };
        const res = await this.$http.personalCenter.userCentert(params);
        this.userInfo = res
      } catch (error) {
        console.error(error);
      }
    },
    //原手机验证码
    async getCode() {
      try {
        let _params = {
          phone: this.userInfo.Phone,
          m: this.$route.query.m,
        }
        console.log(_params)
        const Res = await this.$http.personalCenter.verSendMsg(_params)

        if (Res.Code === 1000) {
          this.codeShow = true
          this.codeBtnShow = false
          // 开启倒计时
          let _time = 60
          let wstime = setInterval(() => {
            _time--
            this.getCAPTCHA = '验证码已发送'+ _time + 's'
            if (_time <= 0) {
              this.getCAPTCHA = ''
              clearTimeout(wstime)
              this.codeShow = false
              this.codeBtnShow = true
            }
          }, 1000)
        } else {
          this.codeShow = false
          this.codeBtnShow = true
          this.getCAPTCHA = ''
          // this.$message({
          //   message: Res.Msg,
          //   type: 'warning'
          // });

        }
      } catch (err) {
        console.log(err)
      }
    },
    //原手机验证码验证
    async getSure() {
      try {
        let _params = {
            phone: this.userInfo.Phone,
            code: this.code,
        }
        const res = await this.$http.personalCenter.checkModfiyUser(_params);
        console.log(res)
        if (res.Code === 1000) {
          this.nowShow = false
          this.modfiyShow = true
        }
      } catch (error) {
        console.error(error);
      }
    },

    //新手机号的验证码
    async getCode1() {
      let telVal = this.modfiyphone
      let re = /^1[1-9]\d{9}$/
      let reTel = re.test(telVal)
      if (reTel === false) {
        this.$message({
          message: '请输入正确的手机号!',
          type: 'warning'
        });
      }else if( this.modfiyphone == this.userInfo.Phone){
        this.$message({
          message: '不能和原手机号相同呦~',
          type: 'warning'
        });
      }else{
        try {
          let _params = {
            m: this.$route.query.m,
            phone: this.modfiyphone,
          }
          const Res = await this.$http.personalCenter.verSendMsg(_params)

          if (Res.Code === 1000) {
            this.send = false
            // 开启倒计时
            let _time = 60
            let wstime = setInterval(() => {
              _time--
              this.getCAPTCHA1 = '验证码已发送'+ _time + 's'
              if (_time <= 0) {
                this.getCAPTCHA1 = '获取验证码'
                clearTimeout(wstime)
                this.send = true
              }
            }, 1000)
          } else {
            this.send = true
            this.getCAPTCHA1 = '获取验证码'
            this.$notify({
              message: Res.Msg,
              type: 'danger',
            })
          }
        } catch (err) {
          console.log(err)
        }
      }
    },
    //确认修改新的手机号
    async modfiySure() {
      let telVal = this.modfiyphone
      let re = /^1[1-9]\d{9}$/
      let reTel = re.test(telVal)
      if (reTel === false) {
        this.$message({
          message: '请输入正确的手机号!',
          type: 'warning'
        });
      }else if(this.code1 == '' || this.code1 == null )  {
        this.$message({
          message: '验证码不能为空!',
          type: 'warning'
        });
      }else{
        try {
          let _params = {
              modfiyphone: this.modfiyphone,
              code: this.code1,
          }
          const res = await this.$http.personalCenter.modfiyPhone(_params);
          console.log(res)
          if (res.Code === 1000) {
            this.$message({
              message: '修改成功',
              type: 'success'
            });
            setTimeout(() => {
              this.$router.go(0);
            }, 2000);
          }
        } catch (error) {
          console.error(error);
        }
      }
    }
  }

};
</script>
<style lang="scss">
.modifyphone {
  padding-bottom: 85px;
  width: 600px;
  margin: 0 auto;
  .modifyphone-con{
    padding: 50px 30px;
    font-size: 16px;
    color: #475569;
    background: #fff;
    border-radius: 20px;
    box-shadow: 0 8px 32px rgba(0,0,0,0.06);
    border: 1px solid #e2e8f0;
    .title{
      font-size: 20px;
      margin-bottom: 40px;
      color: #1e293b;
      font-weight: 700;
    }
    .now-tel{
      font-size: 18px;
      color: #1a3a5c;
    }
    .now-phone{
      border-bottom: 2px solid #e2e8f0;
      margin-top: 20px;
      padding-bottom: 10px;
      font-size: 18px;
      color: #1e293b;
    }
    .now-code{
      display: flex;
      margin-top: 20px;
      height: 40px;
      line-height: 40px;
      div{
        width: 100%;
        height: 40px;
        line-height: 40px;
      }
      .code-input{
        flex: 1;
        border-bottom: 2px solid #e2e8f0;
        input{
          width: 100%;
          height: 40px;
          line-height: 40px;
          border: none;
          background: none;
          font-size: 16px;
          margin-top: -10px;
          color: #2c3e50;
        }
      }
      .code-btn{
        width: 200px;
        text-align: center;
        color: #94a3b8;
        cursor: pointer;
      }
      .code-btn-active{
        border-radius: 8px;
        color: #fff;
        background: #409eff;
        transition: background-color 0.2s;
        &:hover {
          background: #3388e0;
        }
      }
      .code-btn-no{
        background: #dce3ed;
        color: #fff;
        border-radius: 8px;
      }
    }
    .now-code-get{
      width: 240px;
      height: 42px;
      line-height: 42px;
      border-radius: 8px;
      color: #fff;
      background: #409eff;
      text-align: center;
      margin: 50px auto;
      cursor: pointer;
      box-shadow: 0 2px 8px rgba(64, 158, 255, 0.25);
      transition: all 0.2s;
      &:hover {
        background: #3388e0;
        transform: translateY(-1px);
      }
    }
  }
}

</style>


